export const Colors = {
  red: '#f00',
  layerHover: '#ae003c',
  layerSelected: '#e72766',
};
